export default __webpack_public_path__ + "static/media/ADB.3c5447bd.jpeg";